import { SubtypeTask } from "../enums/SubtypeTask";
import { WorkStatusEnum } from "../enums/WorkStatusEnum";

export interface TaskTechnicalReportEligibilityInput {
  assetId?: string | null;
  subtype?: SubtypeTask;
  taskType?: { subtype?: SubtypeTask };
  workTask?: { status?: WorkStatusEnum };
}

function getTaskSubtype(task: TaskTechnicalReportEligibilityInput): SubtypeTask | undefined {
  return task.taskType?.subtype ?? task.subtype;
}

export function doesTaskApplyTechnicalReport(
  task: TaskTechnicalReportEligibilityInput | null | undefined,
  projectHasReport: boolean,
): boolean {
  if (!task) {
    return false;
  }

  if (!projectHasReport || !task.assetId) {
    return false;
  }

  const subtype = getTaskSubtype(task);

  if (subtype === SubtypeTask.STOP) {
    return false;
  }

  return subtype === SubtypeTask.WORK;
}

export function isTechnicalReportRequiredForTask(
  task: TaskTechnicalReportEligibilityInput | null | undefined,
  projectHasReport: boolean,
): boolean {
  if (!doesTaskApplyTechnicalReport(task, projectHasReport)) {
    return false;
  }

  return task?.workTask?.status === WorkStatusEnum.COMPLETED;
}
